import React from "react"; // useState
import MiniDrawer from "./MiniDrawer";
import Breadcrumbs from "./Breadcrumbs";

export const ComingSoon = () => {
  return (
    <>
      <div className="container max-w-screen-2xl flex bg-white dark:bg-[#1C2C3E]  min-h-screen overflow-y-auto">
        <div>
          <MiniDrawer />
        </div>
        <div className="flex flex-col w-full h-screen overflow-y-auto">
          <div className="flex-grow pt-[4rem] md:pt-[4rem] lg:pt-[4rem] px-2 lg:px-3 ">
            <Breadcrumbs />
            <div className="w-full flex pt-[6.6rem] items-center justify-center">
              <div className=" flex p-6 shadow-md rounded-md bg-white text-[#4950bc] font-bold">
                Stay tuned for our exciting new feature, coming soon!
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
